<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-form-group label="Grower" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="grower"
            placeholder="Submission Grower"
            invalid-feedback="Required"
            :state="!$v.grower.$invalid"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Crop"
          :label-cols="2"
          invalid-feedback="Required"
          :state="!$v.crop.$invalid"
          :horizontal="true"
        >
          <add-on-select
            :selectedItem="crop"
            :options="cropOptions"
            :customPlaceholder="'Select Submission Crop Type'"
            @change="handleSelect"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Crop Stage"
          :label-cols="2"
          :disabled="!crop"
          invalid-feedback="Required"
          :state="!$v.cropstage.$invalid"
          :horizontal="true"
        >
          <add-on-select
            :selectedItem="cropstage"
            :options="cropstage_options"
            :customPlaceholder="
              'Select Submission Crop Type Specific Growth Stage'
            "
            @change="handleSelect"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AddOnSelect from "../../misc/AddOnSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "ProjectTissueCropFormGroups",
  components: { AddOnSelect },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: ""
    },
    cropOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    cropStageOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    current_submission() {
      return this.submission(this.submissionId);
    },
    submission_tissue() {
      return this.current_submission.submission_tissue;
    },
    crop() {
      return this.submission_tissue.crop;
    },
    cropstage() {
      return this.submission_tissue.cropstage;
    },
    grower: {
      get() {
        return this.submission_tissue.grower;
      },
      set(value) {
        this.handleSelect({ selected: value, field: "grower" });
      }
    },
    cropstage_options() {
      return {
        ...this.cropStageOptions,
        options:
          (this.crop &&
            this.cropStageOptions.options.filter(
              option => option.parent_id === this.crop
            )) ||
          []
      };
    }
  },
  validations: {
    crop: { required },
    cropstage: { required },
    grower: { required }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSelect({ selected, field }) {
      const submissionUpdate = {
        ...this.submission_tissue,
        [field]: selected
      };
      if (field === "crop") {
        submissionUpdate.cropstage = null;
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: submissionUpdate,
        name: "submission_tissue"
      });
    }
  }
};
</script>
